import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import HelperComponent from '../../../components/HelperComponent/HelperComponent';
import { ERRORS } from '../../../constants/AppConstants';
import { createTopic, getTopics, updateTopic, deleteTopic, getThemes, setTheme, createCommonTopic } from '../../../services/topicsService';
import roundOff from '../../../Util/roundOff';

const Topics = () => {

    const history = useHistory();

    const { isLoggedIn, selectedWebsite } = useAppContext();
    const [ topics, setTopics ] = useState([]);
    const [ topic, setTopic ] = useState('');
    const [ topicError, setTopicError] = useState(null);
    const [is_enabled, setTopicEnabled] = useState(false);

    const websiteOptions = [
        'All Websites',
        'Current Selected'
    ];

    const [selectedWebsiteOption, setSelectedWebsiteOption] = useState('Current Selected');

    useQuery(['fetchTopics', selectedWebsite?.id],  () => getTopics(selectedWebsite?.id) , {
        enabled: isLoggedIn && !!selectedWebsite,
        onSuccess: (topics) => {
            setTopics(topics);
        }
    });

    useQuery(['fetchThemes', selectedWebsite?.id],  () => getThemes(selectedWebsite?.id), {
        enabled: !!selectedWebsite,
        onSuccess: ((themes) => {
            if(themes.errors) {

            }else {
                setTopicEnabled(themes?.is_enabled);
            }
        })
    });


    const handelTopicValidation = (value) => {
        if(value.trim().length <= 0) {
            setTopicError(ERRORS.TOPIC_REQUIRED);
        } else if(value.trim().length > 12) {
            setTopicError(ERRORS.TOPIC_MAX_LENGTH);
        } else {
            setTopicError(null);
        }
        setTopic(value);
    }

    const isAddTopicDisabled = () => {
        return topic.length < 1 || topicError
    }

    const addTopic = useMutation(() => {
        return createTopic({name: topic, is_active: false}, selectedWebsite?.id);
    }, 
     {
        onSuccess: ((response) => {
            if(response.errors) {
                handelError(response.errors)
            } else {
               setTopics([response, ...topics]);
               setTopic('');
               toast.success('Topic added successfully.');
            }
            
        }),
        onError: ((error) => {
            console.log(error)
            // toast.error('Something went wrong');
        })
    });


    const disableTopic = useMutation(({topic, id}) => {
        return updateTopic({topicDetails: topic, webId: selectedWebsite?.id, id})
    }, {
        onSuccess: ((topicDetail) => {
            if(topicDetail.errors) {
                handelError(topicDetail.errors)
            } else {
                const updatedTopics = topics.map((topic) => {
                    if(topic.id === topicDetail.id) {
                        return topicDetail;
                    }
                    return topic;
                });
                setTopics(updatedTopics);   
            }
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });

    const removeTopic = useMutation((id) => {
        return deleteTopic(selectedWebsite.id, id)
    }, {
        onSuccess: ((websiteData, deletedId) => {
            const leftTopics = topics.filter(({id}) => id !== deletedId );
            setTopics(leftTopics);
            toast.success('Topic deleted successfully.');
        })
    })

    const delTopic = (event, id) => {
        event.preventDefault();
        removeTopic.mutate(id);
    }

    const disable = (event, {is_active, id}) => {
        event.preventDefault();
        const topic = {};
        topic.is_active = !is_active;
        disableTopic.mutate({topic, id});
    }

    const themeSetting = () => {
        const activeTopics = topics.filter(({is_active}) => is_active);
        history.push({
            pathname: '/theme-settings',
            state: activeTopics,
        });
    }

    const handelError = (error) => {
        if(error.name) {
            toast.error(ERRORS[error.name[0]]);
        }
        if(error.topics_limit) {
            toast.error(ERRORS[error.topics_limit[0]]);
        }
        if(error.topic_exists) {
            toast.error(ERRORS[error.topic_exists[0]]);
        }
    }

    const disableTopicFeature = useMutation((event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('is_enabled', !is_enabled);
        return setTheme(selectedWebsite?.id, formData);
    }, {
        onSuccess: ( (themeUpdate)=> {
            if(themeUpdate.errors) {
                toast.error(themeUpdate.errors);
            } else {
                setTopicEnabled(!is_enabled);
                toast.success(`Topics ${!is_enabled ? 'enabled' : 'disabled' } successfully`);
            }
        })
    });

    const changeSelectedWebsite = (option) => setSelectedWebsiteOption(option);


    const addCommonTopic = useMutation(() => {
        return createCommonTopic({name: topic, is_active: false}, selectedWebsite?.id);
    }, 
     {
        onSuccess: ((response) => {
            if(response.errors) {
                handelError(response.errors)
            } else {
               setTopics([response, ...topics]);
               setTopic('');
               toast.success('Topic added successfully.');
            }
            
        }),
        onError: ((error) => {
            console.log(error)
            // toast.error('Something went wrong');
        })
    });

    const saveTopic = (event) => {
        event.preventDefault();
        if(selectedWebsiteOption === 'Current Selected') {
            addTopic.mutate();
        } else {
            addCommonTopic.mutate();
        }
    }

    return <>
    <div className="panel full-height">
        <div className="panel-header">
            <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">
                    Topics
                    <HelperComponent 
                        component={'Topics'} 
                        href="https://chirpyweb.com/documentation_posts/topcis/" />    
                </h3>
                <button className="btn btn-primary" onClick={themeSetting} >Theme Settings</button>
            </div>                                
        </div>
        <div className="panel-body full-height scrollable_y">
            <div className="d-flex justify-content-between">
                <p className="regular text-dark py-2">Add or remove topics of interest that your readers can subscribe to.</p>
                <label className="toggle-control toggle-control-sm mb-2">
                    <input type="checkbox" checked={is_enabled} onChange={disableTopicFeature.mutate} />
                    <span className="control"></span>
                </label>
            </div>
            <div className="table-responsive scrollable_y">
                <table className="table table-hover topics-table">
                    <colgroup>
                        <col width="50%"/>
                        <col width="30%"/>
                        <col width="10%"/>
                        <col width="10%"/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td>
                            <div className="form-group mb-0">                   
                                <input 
                                    type="text"
                                    placeholder="Enter New Topic Name" 
                                    className="form-control"
                                    value={topic}
                                    onChange={({target}) => handelTopicValidation(target.value)}  
                                />
                            </div>
                            {topicError && <span className="error-message">{topicError}</span>}
                        </td>
                        <td>
                        <div className="d-flex custom-select align-items-center gap-1">
                                    <div className="medium">Website</div>
                                    <select 
                                        style={{textTransform : 'capitalize'}} 
                                        className="form-control"  
                                        value={selectedWebsiteOption} 
                                        onChange={({target}) => changeSelectedWebsite(target.value)}
                                    >
                                        {
                                            websiteOptions.map((op, index) => <option 
                                                key={index} 
                                                value={op} >{op}</option>)
                                        }    
                                    </select>
                                </div>
                        </td>
                        <td colSpan="2">
                            <button disabled={isAddTopicDisabled()} onClick={saveTopic} className="btn btn-block btn-primary"><i className="icon icon-add mr-1"></i>Add</button>
                        </td>
                    </tr>

                    </tbody>       
                </table>
            </div>
            <div className="table-responsive scrollable_y">
                <table className="table table-hover topics-table">    
                    <colgroup>
                        <col width="60%"/>
                        <col width="20%"/>
                        <col width="10%"/>
                        <col width="10%"/>
                    </colgroup>                                    
                    <thead>                                            
                        <tr>
                            <th>Name</th>
                            <th>Subscribers</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* <tr>
                            <td >
                                <div className="form-group mb-0">                   
                                    <input 
                                        type="text"
                                        placeholder="Enter New Topic Name" 
                                        className="form-control"
                                        value={topic}
                                        onChange={({target}) => handelTopicValidation(target.value)}  
                                    />
                                </div>
                                {topicError && <span className="error-message">{topicError}</span>}
                            </td>
                            <td >
                                <div className="form-group">
                                    <div className="d-flex custom-select align-items-center gap-1">
                                        <div className="medium">Website</div>
                                        <select 
                                            style={{textTransform : 'capitalize'}} 
                                            className="form-control"  
                                            value={selectedWebsiteOption} 
                                            onChange={({target}) => changeSelectedWebsite(target.value)}
                                        >
                                            {
                                                websiteOptions.map((op, index) => <option 
                                                    key={index} 
                                                    value={op} >{op}</option>)
                                            }    
                                        </select>
                                    </div>
                                </div>
                            </td>
                            <td colSpan="2">
                                <button disabled={isAddTopicDisabled()} onClick={addTopic.mutate} className="btn btn-block btn-primary"><i className="icon icon-add mr-1"></i>Add</button>
                            </td>
                        </tr> */}
                        {
                            topics.map((topic, index) => <tr key={index}>
                                <td>{topic.name}</td>
                                <td>{roundOff(topic.audience_reach)}</td>
                                <td>
                                    <label className="toggle-control toggle-control-sm">
                                        <input type="checkbox" checked={topic.is_active}  onChange={(event) => disable(event, topic)} />
                                        <span className="control"></span>
                                    </label>
                                </td>
                                <td><button className="btn btn-danger" onClick={(event) => delTopic(event, topic.id) } ><i className="icon icon-delete"></i></button></td>
                            </tr>)
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</>
};


export default Topics;